import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, SpinnerComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnDestroy, OnInit {
  private unsubscribe: Subscription[] = [];
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const sessionSubscr = this.authService
      .getUserBySession()
      .pipe(first())
      .subscribe((session) => {
        if (session?.session) {
          this.router.navigate(['/dashboard']);
          return;
        }

        this.login('AzureAD');
      });

    this.unsubscribe.push(sessionSubscr);
  }

  login(provider: string) {
    console.log(`Login with ${provider} fron login component`);
    const loginSubscr = this.authService
      .loginSSO(provider)
      .pipe(first())
      .subscribe({
        next: (result: any) => {
          console.log('Login successful', result);
          this.router.navigate(['/dashboard']);
        },
        error: (error: any) => {
          const errorMessage = error?.message ?? '';

          // Avoid a login loop when Amplify indicates the user already has a session.
          if (
            error?.name === 'UserAlreadyAuthenticatedException' ||
            errorMessage.includes('already a signed in user') ||
            errorMessage.includes('already logged in')
          ) {
            console.log('User already authenticated, redirecting to dashboard');
            this.router.navigate(['/dashboard']);
            return;
          }

          console.error('Error logging in', error);
        },
      });
    this.unsubscribe.push(loginSubscr);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((obs) => obs.unsubscribe());
  }
}
